import { createAsyncThunk } from "@reduxjs/toolkit";
import { CondimentService } from "../../services/CondimentService";
import { CondimentInterface } from "../../entities/Condiment";
import type { AxiosError, AxiosRequestConfig } from "axios";
import { RootState } from "../../store/store";
import { getSelectedCondiments } from "./selectors";
import { keepSelectedCondiments } from "../../utils/keepSelectedCondiments";
import { transformCondiments } from "../../utils/transformCondiments";

export const fetchCondiments = createAsyncThunk<
  CondimentInterface[],
  AxiosRequestConfig,
  { rejectValue: AxiosError }
>(
  "condiment/fetchAll",
  async (params: AxiosRequestConfig, { rejectWithValue, getState }) => {
    try {
      const { data } = await CondimentService.getCondiments(params);

      const transformedCondiments = transformCondiments(data);

      const state = getState() as RootState;
      const selectedCondiments = getSelectedCondiments(state);

      if (selectedCondiments.length === 0) return transformedCondiments;
      const condiments = keepSelectedCondiments(
        transformedCondiments,
        selectedCondiments,
      );
      return condiments;
    } catch (e: any) {
      return rejectWithValue(e.message as AxiosError);
    }
  },
);

export const fetchHarmonyCondiments = createAsyncThunk<
  CondimentInterface[],
  string,
  { rejectValue: AxiosError }
>(
  "condiment/fetchHarmonyCondiments",
  async (harmonyId: string, { rejectWithValue }) => {
    try {
      const response = await CondimentService.getHarmonies(harmonyId);

      const harmonies = response.harmonies.map((item: CondimentInterface) => ({
        ...item,
        id: item.condimentId ?? item.id,
      }));

      const transformedHarmonies = transformCondiments(harmonies);

      const filteredHarmoniesWithPricesAndMeta: CondimentInterface[] =
        transformedHarmonies.map((item: CondimentInterface) => {
          return item.id === parseFloat(harmonyId)
            ? { ...item, meta: { ...item.meta, hidden: true, selected: true } }
            : item;
        });

      return filteredHarmoniesWithPricesAndMeta;
    } catch (e: any) {
      return rejectWithValue(e.message as AxiosError);
    }
  },
);
